import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { autocompleteCategory } from "@/graphql/queries";
import { create } from "zustand";
import type { State } from "@/types/common";
import type { AutocompleteCategoryQuery } from "@/API";
import type { GraphQLError } from "graphql";

const client = generateClient();

export const autoCompleteCategoriesState = create<
  State<AutocompleteCategoryQuery>
>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const autoCompleteCategoriesStateIsloading = () =>
  autoCompleteCategoriesState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const autoCompleteCategoriesStateIsError = (error: GraphQLError[]) =>
  autoCompleteCategoriesState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const autoCompleteCategoriesStateIsSuccess = (
  queryResult: AutocompleteCategoryQuery,
) =>
  autoCompleteCategoriesState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
  }));

export type searchForAutoCompleteCategoriesParams = {
  search: string;
};

export const searchForAutoCompleteCategories = async ({
  search,
}: searchForAutoCompleteCategoriesParams) => {
  autoCompleteCategoriesStateIsloading();

  try {
    const response = await client.graphql({
      query: autocompleteCategory,
      variables: {
        value: search,
      },
    });

    autoCompleteCategoriesStateIsSuccess(
      response.data as AutocompleteCategoryQuery,
    );
  } catch (e: unknown) {
    const graphQl = e as GraphQLResult<AutocompleteCategoryQuery>;
    autoCompleteCategoriesStateIsError(graphQl.errors as GraphQLError[]);
  }
};
